import { createFileRoute } from "@tanstack/react-router"
import { ManualLaunch } from "modules/campaigns/components/Detail/ManualLaunch"
import { z } from "zod"

const SearchSchema = z.object({
  importId: z.string().uuid().optional(),
})

export const Route = createFileRoute("/_base/_auth/campaigns/$id/insights/launch")({
  validateSearch: SearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  const { importId } = Route.useSearch()

  return (
    <ManualLaunch
      campaignId={id}
      importId={importId}
      onClose={() => {
        navigate({
          to: "/campaigns/$id/insights",
          params: { id },
          search: {},
        })
      }}
    />
  )
}
